app
  .controller("VideoBannerController", [
    "$scope",
    "$sce",
    function ($scope, $sce) {
      if ($scope.payload.url) {
        $scope.videoUrl = $scope.payload.url;
      }
      if ($scope.payload.text) {
        $scope.callToActionElements = $sce.trustAsHtml($scope.payload.text);
      }
      if ($scope.payload.overlayColor) {
        let bodyStyle = document.body.style;
        bodyStyle.setProperty("--overlay", $scope.payload.overlayColor);
      }
    },
  ])
  .directive("videoBanner", function () {
    return {
      restrict: "AE",
      transclude: true,
      scope: {
        payload: "=",
      },
      templateUrl: "template/elements/videoBanner.html",
    };
  });
